export class EnableMessage {
  constructor() {}

  maintenance = 'modal.maintenance';
  
}

